/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geocountryaccounts2Inputs */

const en_geocountryaccounts2 = /** @type {(inputs: Geocountryaccounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounts by country of residence`)
};

const de_geocountryaccounts2 = /** @type {(inputs: Geocountryaccounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten nach Wohnsitzland`)
};

/**
* | output |
* | --- |
* | "Accounts by country of residence" |
*
* @param {Geocountryaccounts2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geocountryaccounts2 = /** @type {((inputs?: Geocountryaccounts2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geocountryaccounts2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geocountryaccounts2(inputs)
	return de_geocountryaccounts2(inputs)
});
export { geocountryaccounts2 as "geoCountryAccounts" }